function w(n) {
  return Array.isArray(n) ? n : String(n).split(/[eE]/);
}
function S(n) {
  const t = w(n);
  return !Number.isNaN(Number(t[1]));
}
function $(n) {
  const t = w(n);
  if (!S(t))
    return t[0];
  const r = t[0][0] === "-" ? "-" : "", e = t[0].replace(/^-/, "").split("."), u = e[0], s = e[1] || "";
  let i = Number(t[1]);
  if (i === 0)
    return `${r + u}.${s}`;
  if (i < 0) {
    const c = u.length + i;
    if (c > 0) {
      const f = u.substr(0, c), a = u.substr(c);
      return `${r + f}.${a}${s}`;
    } else {
      let f = "0.";
      for (i = c; i; )
        f += "0", i += 1;
      return r + f + u + s;
    }
  } else {
    const c = s.length - i;
    if (c > 0) {
      const f = s.substr(i), a = s.substr(0, i);
      return `${r + u + a}.${f}`;
    } else {
      let f = -c, a = "";
      for (; f; )
        a += "0", f -= 1;
      return r + u + s + a;
    }
  }
}
function D(n, t) {
  const r = t > 0n ? n : -n, o = t > 0n ? t : -t, u = r % o > 0n ? 1n : 0n;
  return r / o + u;
}
function T(n, t) {
  const r = t > 0n ? n : -n, o = t > 0n ? t : -t, u = r % o < 0n ? -1n : 0n;
  return r / o + u;
}
function y(n, t) {
  const r = t > 0n ? n : -n, o = t > 0n ? t : -t, e = r < 0n ? -1n : 1n;
  return (r * e + o / 2n) / o * e;
}
function A(n, t, r = "ROUND_HALF") {
  return r === "ROUND_UP" ? D(n, t) : r === "ROUND_DOWN" ? T(n, t) : y(n, t);
}
function P(n) {
  let [t, r = "0"] = n.split(".");
  return t === "" && (t = "0"), r = r.replace(/(?!^)0*$/, ""), [t, r];
}
function _(n) {
  return BigInt("1" + "0".repeat(n));
}
function F(n, t) {
  const r = n / t * t, o = r + t;
  return n - r >= o - n ? o : r;
}
function I(n, t) {
  return n / t * t + t;
}
function O(n, t) {
  return n / t * t;
}
function p(n) {
  return n < 0n ? -n : n;
}
function d(n) {
  return Array.isArray(n) && typeof n[0] == "bigint" && typeof n[1] == "number";
}
const x = /^-?(?:[0-9]+|(?:[0-9]*(?:\.[0-9]+)))$/;
function N(n, t = !0) {
  if (d(n))
    return l(n, t === !0 ? n[1] : t);
  if (n = String(n), n.includes("e") && (n = $(n)), !n.match(x))
    throw new Error(`dnum: incorrect number (${n})`);
  const r = n.startsWith("-");
  r && (n = n.slice(1));
  const o = P(n), e = o[0];
  let u = o[1];
  return t === !0 && (t = u === "0" ? 0 : u.length), u = u.slice(0, t), u = u + "0".repeat(t - u.length), [(BigInt(e) * _(t) + BigInt(u)) * (r ? -1n : 1n), t];
}
function b(n, t, r = {}) {
  return r.rounding ??= "ROUND_HALF", t > 0 ? n * _(t) : t < 0 ? A(n, _(-t), r.rounding) : n;
}
function l(n, t, r = {}) {
  if (r.rounding ??= "ROUND_HALF", n[1] === t)
    return n;
  if (n[1] < 0 || t < 0)
    throw new Error("dnum: decimals cannot be negative");
  const o = t - n[1];
  return [
    b(n[0], o, r),
    t
  ];
}
function E(n, t) {
  const r = t ?? Math.max(...n.map(([, o]) => o), 0);
  return n.map((o) => l(o, r));
}
function L([n, t]) {
  return JSON.stringify([String(n), t]);
}
function W(n) {
  const [t, r] = JSON.parse(n);
  return [BigInt(t), r];
}
function R(n, t = {}) {
  const [r, o] = n, e = typeof t == "number" ? { digits: t } : t, {
    digits: u = o,
    trailingZeros: s,
    decimalsRounding: i
  } = e, c = _(o);
  let f = r / c;
  const a = p(r % c);
  let m = String(
    (i === "ROUND_UP" ? I : i === "ROUND_DOWN" ? O : F)(
      BigInt(
        // prefix with 1 to keep the leading zeros
        "1" + "0".repeat(
          Math.max(
            0,
            String(c).length - String(a).length - 1
          )
        ) + String(a)
      ),
      _(Math.max(0, o - u))
    )
  );
  return m.startsWith("2") && (f += 1n), m = m.slice(1, u + 1), m = s ? m.padEnd(u, "0") : m.replace(/0+$/, ""), [
    p(f),
    m === "" || BigInt(m) === 0n && !s ? null : m
  ];
}
function z(n, t) {
  return Number(B(n, t));
}
function B(n, t) {
  const [r, o] = R(n, t);
  return (n[0] >= 0n ? "" : "-") + r + (o ? `.${o}` : "");
}
function M(n, t = {}) {
  const r = typeof t == "number" ? { digits: t } : t, {
    compact: o,
    locale: e = Intl.NumberFormat().resolvedOptions().locale,
    signDisplay: u = "auto",
    ...s
  } = r, [i, c] = R(n, s), f = new Intl.NumberFormat(e).formatToParts(0.1).find((m) => m.type === "decimal")?.value ?? ".", a = i === 0n && (c === null || /^0+$/.test(c)), h = H(
    n,
    a,
    u
  ) + BigInt(i).toLocaleString(e, {
    notation: o ? "compact" : "standard"
  });
  return c === null || !/\d/.test(h.at(-1)) ? h : `${h}${f}${c}`;
}
function H(n, t, r) {
  return r === "auto" ? n[0] >= 0n ? "" : "-" : r === "always" ? n[0] >= 0n ? "+" : "-" : r === "exceptZero" ? t ? "" : n[0] >= 0n ? "+" : "-" : r === "negative" ? n[0] >= 0n || t ? "" : "-" : "";
}
function J(n, t, r) {
  const [o, e] = g(n, t, r);
  return l(
    [o[0] + e[0], o[1]],
    r ?? (d(n) ? n[1] : o[1])
  );
}
function q(n, t, r) {
  const [o, e] = g(n, t, r);
  return l(
    [o[0] - e[0], o[1]],
    r ?? (d(n) ? n[1] : o[1])
  );
}
function V(n, t, r = {}) {
  const o = typeof r == "number" ? { decimals: r } : r;
  o.rounding ??= "ROUND_HALF";
  const [e, u] = g(n, t, o.decimals);
  return l(
    [e[0] * u[0], e[1] * 2],
    o.decimals ?? (d(n) ? n[1] : e[1]),
    { rounding: o.rounding }
  );
}
function Z(n, t, r = {}) {
  const o = typeof r == "number" ? { decimals: r } : r;
  o.rounding ??= "ROUND_HALF";
  const [e, u] = g(n, t, o.decimals);
  if (u[0] === 0n)
    throw new Error("dnum: division by zero");
  const s = b(
    e[0],
    Math.max(e[1], o.decimals ?? 0)
  ), i = b(u[0], 0);
  return l(
    [A(s, i, o.rounding), e[1]],
    o.decimals ?? (d(n) ? n[1] : e[1]),
    { rounding: o.rounding }
  );
}
function C(n, t, r) {
  const [o, e] = g(n, t);
  return l(
    [o[0] % e[0], o[1]],
    r ?? (d(n) ? n[1] : o[1])
  );
}
function j(n, t) {
  const [r, o] = g(n, t);
  return r[0] > o[0] ? 1 : r[0] < o[0] ? -1 : 0;
}
function k(n, t) {
  const [r, o] = g(n, t);
  return r[0] === o[0];
}
function G(n, t) {
  const [r, o] = g(n, t);
  return r[0] > o[0];
}
function K(n, t) {
  const [r, o] = g(n, t);
  return r[0] < o[0];
}
function Q(n, t) {
  const [r, o] = N(n);
  t === void 0 && (t = o);
  let e = r;
  return e < 0n && (e = -e), l([e, o], t);
}
function X(n, t) {
  return U(n, { decimals: t, rounding: "ROUND_DOWN" });
}
function Y(n, t) {
  return U(n, { decimals: t, rounding: "ROUND_UP" });
}
function U(n, t = {}) {
  const r = typeof t == "number" ? { decimals: t } : t;
  r.rounding ??= "ROUND_HALF";
  const o = N(n);
  return l(
    l(o, 0, { rounding: r.rounding }),
    // setDecimals() uses divideAndRound() internally
    r.decimals === void 0 ? o[1] : r.decimals
  );
}
function g(n, t, r) {
  const o = N(n), e = N(t);
  if (o[1] < 0 || e[1] < 0)
    throw new Error("dnum: decimals cannot be negative");
  return E(
    [o, e],
    Math.max(o[1], e[1], r ?? 0)
  );
}
export {
  Q as abs,
  J as add,
  Y as ceil,
  j as cmp,
  j as compare,
  Z as div,
  Z as divide,
  k as eq,
  k as equal,
  E as equalizeDecimals,
  X as floor,
  M as format,
  N as from,
  W as fromJSON,
  G as greaterThan,
  G as gt,
  d as isDnum,
  K as lessThan,
  K as lt,
  V as mul,
  V as multiply,
  C as rem,
  C as remainder,
  U as round,
  l as setDecimals,
  q as sub,
  q as subtract,
  L as toJSON,
  z as toNumber,
  R as toParts,
  B as toString
};
//# sourceMappingURL=dnum.js.map
